export interface Condition {
  condition?: 'AND' | 'OR';
}
